
export default function FamilyPharmacistGuidePage() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <a href="/" className="text-2xl font-bold text-orange-600" style={{ fontFamily: '"Pacifico", serif' }}>
                logo
              </a>
            </div>
            <nav className="hidden md:flex space-x-8">
              <a href="/" className="text-gray-700 hover:text-orange-600 transition-colors">
                ホーム
              </a>
              <a href="/services" className="text-gray-700 hover:text-orange-600 transition-colors">
                サービス
              </a>
              <a href="/beast-blog" className="text-orange-600 font-medium">
                ビースト君ブログ
              </a>
              <a href="/information" className="text-gray-700 hover:text-orange-600 transition-colors">
                お知らせ
              </a>
            </nav>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="bg-gradient-to-br from-orange-50 to-amber-50 py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <div className="flex justify-center items-center mb-6">
              <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center">
                <i className="ri-user-heart-line text-2xl text-white"></i>
              </div>
            </div>
            <h1 className="text-4xl font-bold text-gray-900 mb-4">
              かかりつけ薬剤師とは？メリットと登録方法を徹底解説
            </h1>
          </div>
        </div>
      </section>

      {/* Article Content */}
      <article className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Introduction */}
          <section className="mb-12">
            <div className="bg-orange-50 border-l-4 border-orange-500 p-6 mb-8">
              <p className="text-lg text-gray-700 leading-relaxed">
                かかりつけ薬剤師制度は、患者さんが特定の薬剤師と継続的な関係を築き、より安全で効果的な薬物療法を受けるための制度です。この記事では、かかりつけ薬剤師のメリットや登録方法について詳しく解説します。
              </p>
            </div>
          </section>

          {/* What is Kakariuke Pharmacist */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center">
              <i className="ri-question-line text-orange-500 mr-3"></i>
              かかりつけ薬剤師とは
            </h2>
            <div className="bg-white border border-gray-200 rounded-lg p-6 mb-6">
              <p className="text-gray-700 mb-4 leading-relaxed">
                かかりつけ薬剤師とは、患者さんが服用している全ての薬について一元的・継続的に管理し、薬学的知見に基づく指導を行う薬剤師のことです。2016年4月に診療報酬改定で新設された制度で、患者さんの薬物療法の安全性と有効性の向上を目的としています。
              </p>
              <div className="bg-orange-50 p-4 rounded-lg">
                <h3 className="font-semibold text-gray-900 mb-2">かかりつけ薬剤師の定義</h3>
                <ul className="list-disc list-inside text-gray-700 space-y-1">
                  <li>患者さんの同意を得て指名された薬剤師</li>
                  <li>患者さんの薬歴を一元的に管理</li>
                  <li>24時間対応可能な体制を整備</li>
                  <li>在宅医療への対応も可能</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Benefits */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center">
              <i className="ri-heart-pulse-line text-orange-500 mr-3"></i>
              かかりつけ薬剤師のメリット
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
              <div className="bg-white border border-gray-200 rounded-lg p-6">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-shield-check-line text-blue-600 text-xl"></i>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900">薬の安全性向上</h3>
                </div>
                <ul className="text-gray-700 space-y-2">
                  <li>• 重複投薬の防止</li>
                  <li>• 相互作用のチェック</li>
                  <li>• 副作用の早期発見</li>
                  <li>• アレルギー歴の管理</li>
                </ul>
              </div>

              <div className="bg-white border border-gray-200 rounded-lg p-6">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-user-heart-line text-green-600 text-xl"></i>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900">個別対応の充実</h3>
                </div>
                <ul className="text-gray-700 space-y-2">
                  <li>• 患者さんの状況に応じた指導</li>
                  <li>• 生活習慣を考慮した服薬指導</li>
                  <li>• 継続的な健康サポート</li>
                  <li>• 薬の効果・副作用の追跡</li>
                </ul>
              </div>

              <div className="bg-white border border-gray-200 rounded-lg p-6">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-time-line text-purple-600 text-xl"></i>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900">24時間対応</h3>
                </div>
                <ul className="text-gray-700 space-y-2">
                  <li>• 緊急時の相談対応</li>
                  <li>• 夜間・休日の薬の相談</li>
                  <li>• 副作用発現時の対応</li>
                  <li>• 服薬に関する不安解消</li>
                </ul>
              </div>

              <div className="bg-white border border-gray-200 rounded-lg p-6">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-home-heart-line text-orange-600 text-xl"></i>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900">在宅医療対応</h3>
                </div>
                <ul className="text-gray-700 space-y-2">
                  <li>• 自宅での服薬指導</li>
                  <li>• 薬の管理方法の指導</li>
                  <li>• 介護者への説明</li>
                  <li>• 医師との連携強化</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Requirements */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center">
              <i className="ri-file-list-3-line text-orange-500 mr-3"></i>
              かかりつけ薬剤師になるための要件
            </h2>
            <div className="bg-white border border-gray-200 rounded-lg p-6 mb-6">
              <p className="text-gray-700 mb-4">
                かかりつけ薬剤師として指名されるためには、以下の要件を満たす必要があります：
              </p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <h3 className="font-semibold text-gray-900 mb-3">基本要件</h3>
                  <ul className="list-disc list-inside text-gray-700 space-y-2">
                    <li>薬剤師として3年以上の薬局勤務経験</li>
                    <li>当該薬局で1年以上の勤務</li>
                    <li>週32時間以上の勤務</li>
                    <li>研修認定薬剤師の資格取得</li>
                  </ul>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-3">体制要件</h3>
                  <ul className="list-disc list-inside text-gray-700 space-y-2">
                    <li>24時間対応可能な連絡体制</li>
                    <li>在宅医療への対応体制</li>
                    <li>医療機関との連携体制</li>
                    <li>継続的な研修受講</li>
                  </ul>
                </div>
              </div>
            </div>
          </section>

          {/* Registration Process */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center">
              <i className="ri-user-add-line text-orange-500 mr-3"></i>
              かかりつけ薬剤師の登録方法
            </h2>
            <div className="space-y-6">
              <div className="bg-white border border-gray-200 rounded-lg p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-4">患者さん側の手続き</h3>
                <div className="space-y-4">
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-orange-500 text-white rounded-full flex items-center justify-center mr-4 mt-1 text-sm font-bold">
                      1
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-2">薬局・薬剤師の選択</h4>
                      <p className="text-gray-700">
                        信頼できる薬局と薬剤師を選び、かかりつけ薬剤師として指名したい旨を伝えます。
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-orange-500 text-white rounded-full flex items-center justify-center mr-4 mt-1 text-sm font-bold">
                      2
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-2">同意書の記入</h4>
                      <p className="text-gray-700">
                        かかりつけ薬剤師指名に関する同意書に記入し、正式に契約を結びます。
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-orange-500 text-white rounded-full flex items-center justify-center mr-4 mt-1 text-sm font-bold">
                      3
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-2">薬歴情報の提供</h4>
                      <p className="text-gray-700">
                        現在服用中の薬、アレルギー歴、既往歴などの情報を詳しく提供します。
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-orange-500 text-white rounded-full flex items-center justify-center mr-4 mt-1 text-sm font-bold">
                      4
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-2">継続的な関係の構築</h4>
                      <p className="text-gray-700">
                        定期的な相談や服薬指導を通じて、薬剤師との信頼関係を築いていきます。
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* 費用と保険適用 */}
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 mb-8">
            <h3 className="text-lg font-semibold text-blue-800 mb-4">💰 かかりつけ薬剤師指導料について</h3>
            <div className="space-y-2 text-blue-700">
              <p>
                <strong>基本料金：</strong> 76点（760円）
              </p>
              <p>
                <strong>患者負担：</strong> 3割負担で約250円
              </p>
              <p className="text-sm">※薬剤服用歴管理指導料に代わって算定</p>
            </div>
          </div>

          {/* 注意事項 */}
          <div className="bg-orange-50 border-l-4 border-orange-400 p-6 rounded-lg">
            <h3 className="text-lg font-bold text-orange-800 mb-3">
              <i className="ri-alert-line mr-2"></i>
              注意事項
            </h3>
            <p className="text-orange-700">
              <strong>注意：</strong> かかりつけ薬剤師指導料は、通常の薬剤服用歴管理指導料（45点）よりも高く設定されていますが、より充実したサービスを受けることができます（医療機関への情報共有：トレーシングレポート）。
            </p>
          </div>

          {/* How to Choose */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center">
              <i className="ri-search-line text-orange-500 mr-3"></i>
              良いかかりつけ薬剤師の選び方
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* チェックポイント */}
              <div className="bg-white border border-gray-200 rounded-lg p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-4">チェックポイント</h3>
                <ul className="space-y-3">
                  <li className="flex items-start">
                    <i className="ri-check-line text-green-500 mr-2 mt-1"></i>
                    <span className="text-gray-700">丁寧で分かりやすい説明をしてくれる</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-green-500 mr-2 mt-1"></i>
                    <span className="text-gray-700">患者の話をよく聞いてくれる</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-green-500 mr-2 mt-1"></i>
                    <span className="text-gray-700">専門知識が豊富で信頼できる</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-green-500 mr-2 mt-1"></i>
                    <span className="text-gray-700">アクセスが良く通いやすい立地</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-green-500 mr-2 mt-1"></i>
                    <span className="text-gray-700">24時間対応体制が整っている</span>
                  </li>
                </ul>
              </div>

              {/* 避けるべき薬局 */}
              <div className="bg-white border border-gray-200 rounded-lg p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-4">避けるべき薬局</h3>
                <ul className="space-y-3">
                  <li className="flex items-start">
                    <i className="ri-close-line text-red-500 mr-2 mt-1"></i>
                    <span className="text-gray-700">説明が不十分で質問しにくい</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-close-line text-red-500 mr-2 mt-1"></i>
                    <span className="text-gray-700">対応が遅く、緊急時に不安になる</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-close-line text-red-500 mr-2 mt-1"></i>
                    <span className="text-gray-700">情報共有が不透明で信頼性が低い</span>
                  </li>
                </ul>
              </div>
            </div>
          </section>
        </div>
      </article>
    </div>
  );
}
